import { render, staticRenderFns } from "./Floating.vue?vue&type=template&id=74ac83e2&scoped=true"
import script from "./Floating.vue?vue&type=script&lang=js"
export * from "./Floating.vue?vue&type=script&lang=js"
import style0 from "./Floating.vue?vue&type=style&index=0&id=74ac83e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ac83e2",
  null
  
)

export default component.exports